module.exports = __webpack_public_path__ + "static/media/chat-assistant-2.63da3a3c.png";